import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

const ConfirmationDialog: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { isOpen, onClose, onSubmit, children } = props;

    return (
        <Dialog open={isOpen} onClose={onClose}>
            <DialogContent>{children}</DialogContent>
            <DialogActions>
                <Button variant="outlined" color="secondary" onClick={onClose}>
                    {t('Cancel')}
                </Button>
                <Button variant="contained" onClick={onSubmit} autoFocus>
                    {t('Ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
